import { Component, Input } from '@angular/core';
import { MatDialog } from '@angular/material/dialog';
import { NotificationService } from 'src/app/core/common-services/notification.service';
import { AddRequestAttachmentDto, RequestAttachmentDto } from 'src/app/core/data-models/workflow.data.models';
import { RequestAttachmentsDataService } from 'src/app/core/data-services/workflow/request-attachments-data.service';
import { KycDataService } from 'src/app/features/investor-portal/services/kyc.data.service';
import { ConfirmationDialogComponent } from '../confirmation-dialog/confirmation-dialog.component';

@Component({
  selector: 'app-workflow-request-attachments',
  templateUrl: './workflow-request-attachments.component.html',
  styleUrls: ['./workflow-request-attachments.component.css']
})
export class WorkflowRequestAttachmentsComponent {
  @Input() requestId!: string;
  requestAttachments: RequestAttachmentDto[] = [];
  requestAttachmentsFiltered: RequestAttachmentDto[] = [];
  fileName=''; 
  uploadDate='';
  uploadedBy='';

  constructor(
    private requestAttachmentsDataService: RequestAttachmentsDataService,
    private kycDataService: KycDataService,
    private dialog: MatDialog,
    private notificationService: NotificationService
  ) { }

  ngOnInit(): void {
    this.loadData();
  }
  loadData(){
    this.requestAttachmentsDataService.get(this.requestId).subscribe((response) => {
      this.requestAttachments = response.resource;
      this.requestAttachmentsFiltered = this.requestAttachments;
    });
  }
  delete(id: string): void {
    const confirmConfig = {
      message: ("Are you sure to delete attachment"),
      trueText: ('Delete'),
      falseText: 'Cancel'
    };

    this.dialog.open(ConfirmationDialogComponent, { data: confirmConfig })
      .afterClosed().subscribe(result => {
        if (result) {
          this.requestAttachmentsDataService.delete(id).subscribe((response) => {
            this.loadData();
          });
          this.requestAttachmentsDataService.delete(id).subscribe({
            next: (res) => {
                this.loadData();
                this.notificationService.success('Attachment has been deleted successfully!');
              
            },
            error: (error: any) => {
              this.notificationService.error("Somthing went wrong!")
            }
          })
        }
      });



   
  } 

  add(requestAttachment: AddRequestAttachmentDto): void {
    this.requestAttachmentsDataService.add(requestAttachment).subscribe((response) => {
      this.loadData();
    });
  }
  onFileSelected(event: Event) {
    const input = event.target as HTMLInputElement;

    if (input.files && input.files.length > 0) {
      const file = input.files[0];

      // Get the file extension
      let fileName=file.name;
      let fileExtension = file.name.split('.').pop()!;

      // Convert the file to Base64
      const reader = new FileReader();
      reader.onload = () => {
        let base64Data = reader.result as string;
        const pureBase64String = base64Data.split(',') [1];

          this.kycDataService.UploadDocKyc({ fileBase64: pureBase64String, fileExtention: fileExtension }).subscribe({
         
            next: (res: any) => {
              let url = res.data;
              this.add({ requestId: this.requestId, title: fileName, url: url });
            },
            error:(error)=>{
              let msg='Somthing went wrong!';
              if(error.error.data){
                msg=JSON.parse(error.error.data).Message||'Somthing went wrong!';
              }
              this.notificationService.error(msg);
            }
  
          })
        

      };
      reader.readAsDataURL(file);
    }

  }
filter(){
  this.requestAttachmentsFiltered = this.requestAttachments.filter((attachment) => {
    // Filter by fileName
    const fileNameMatch = attachment.title.toLowerCase().includes(this.fileName.toLowerCase());
    
    // Filter by uploadedBy
    const uploadedByMatch = attachment.createBy.toLowerCase().includes(this.uploadedBy.toLowerCase());
    
    // Filter by uploadDate - extract only date part (day, month, year)
    let uploadDateMatch = true;
    if (this.uploadDate) {
      const attachmentDate = new Date(attachment.createAt);
      const filterDate = new Date(this.uploadDate);
      
      // Compare only year, month, and day
      uploadDateMatch = attachmentDate.getFullYear() === filterDate.getFullYear() &&
                       attachmentDate.getMonth() === filterDate.getMonth() &&
                       attachmentDate.getDate() === filterDate.getDate();
    }
    
    return fileNameMatch && uploadDateMatch && uploadedByMatch;
  });
}

}
